module.exports = __webpack_public_path__ + "img/0-119.a0a10573.jpg";